(ns dre.components.widget.views.header
  (:require
   ["antd" :refer [Spin]]
   ["dom-to-image-more" :as domtoimage]
   [dre.components.dropdown :refer [dropdown dropdown-list]]
   [dre.components.icon :refer [svg icon fa-icon]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.events :as-alias i18n]
   [dre.utils.bem :as bem]
   [dre.fx :as-alias dre.fx]
   [dre.widgets.events :as-alias widgets]
   [reagent.core :as r]
   [dre.components.radio-group :refer [radio-group]]
   [re-frame.core :as rf]
   [dre.components.widget.events :as events]))


(def component-name :widget-header)

(defn dismiss-button
  [id]
  [tooltip-wrapper "Dismiss" [:button
                              {:class (bem/bm :button :bare)
                               :on-click #(rf/dispatch [::widgets/toggle-active id])}
                              [svg :common :dismiss]]])

(defn menu-button
  []
  [tooltip-wrapper "Menu" [:button
                           {:class (bem/bm :button :bare)}
                           [svg :common :dotburger]]])

(defn node->img
  [node title]
  (-> (domtoimage/toBlob node #js {:width node.offsetWidth
                                   :height node.offsetHeight
                                   :filter
                                   (fn [node]
                                     (not (when-let [cl (.-classList node)]
                                            (or (.contains cl "skip-camera")
                                                (.contains cl "react-resizable-handle")))))})
      (.then (fn [blob]
              (rf/dispatch [::dre.fx/download {:content blob
                                               :filename (str title ".png")
                                               :mimetype "image/png"}])))))
(defn export-image
  "Export Image component"
  [title]
  [:span
   {:class (bem/be component-name :menu-item)
    :on-click
    (fn [ev]
      (when-let
       [node (-> (.-currentTarget ev)
                 (.closest ".widget"))]
        (node->img node title)))}
   [fa-icon :camera]
   [tr "Download image"]])

(defn export-csv
  "Export widget data to CSV by count"
  [export-counts csv-event title export-image?]
  (let [export-count @(rf/subscribe [::events/get-export-count (keyword title)])
        export-count (if-not export-count
                       (-> export-counts
                           first
                           :id)
                       export-count)]
    [:div
     {:class (bem/be component-name :export-csv-component)}
     [tr "Export"]
     [:div
      {:class (bem/be component-name :export-csv-controls)}
      [radio-group
       {:on-change #(rf/dispatch [::events/set-export-count (keyword title) (:value %)])
        :checked export-count
        :options export-counts}]
      [:button
       {:class (bem/be component-name :button)
        :on-click #(rf/dispatch csv-event)}
       [fa-icon :download]]]
     (when export-image?
       [export-image title])]))

(defn widget-menu
  [title widget-menu-opts]
  (let [{:keys [csv-event csv-event-loading? export-image? export-counts]} widget-menu-opts]
    [:span
     {:class [(bem/be component-name :menu) :skip-camera]}
     [dropdown
      {:alignment :left
       :anchor
       [menu-button]
       :content
       (if (and csv-event export-counts)
         [:> Spin {:spinning csv-event-loading?}
          [export-csv export-counts csv-event title export-image?]]
         [:> Spin {:spinning csv-event-loading?}
          [dropdown-list
           [(when csv-event
              [:span
               {:class (bem/be component-name :menu-item)
                :on-click #(rf/dispatch csv-event)}
               [fa-icon :file-export]
               [tr "Export"]])
            (when export-image?
              [export-image title])]]])}]]))

(defn header-controls
  [selection widget-id]
  (let
   [selection-id (:id selection)
    on-change (or (:on-change selection) identity)
    state @(rf/subscribe [::events/selection widget-id selection-id])]
    (if (= :tabs (:type selection))
      [:span
       (doall
        (for [{:keys [id label tooltip]}
              (:options selection)]
          (with-meta
            (let [has-state? (not (nil? state))
                  active? (if has-state? (= id state)
                              (= id (:default-option selection)))
                  content [:span {:on-click
                                  #(do
                                     (on-change id)
                                     (rf/dispatch [::events/set-selection widget-id selection-id id]))
                                  :class [(bem/bm :widget-tab-selection (when active? "active")) (bem/bm :button [:light :small])]}
                           label]]
              (if tooltip
                [tooltip-wrapper tooltip content]
                content))
            {:key id})))]

      (let
       [selected-id (if (not (nil? state))
                      state
                      (:default-option selection))
        selected-option (first (filter #(= (:id %) selected-id) (:options selection)))]
        [dropdown
         {:alignment :right
          :class (:class selection)
          :anchor
          [:button
           {:class [:widget-tab-selection (bem/bm :button [:light :small])]}
           (or (:selected-label selected-option)
               (:label selected-option))
           "\u00A0""\u00A0"
           (icoinor-icon :nav-arrow-down)]
          :content
          [dropdown-list
           (for [{:keys [id label]}
                 (:options selection)]
             ^{:key id}
             [:span {:on-click
                     #(do
                        (on-change id)
                        (rf/dispatch [::events/set-selection widget-id selection-id id]))}
              label])]}]))))

(defn selections-menu
  [id widget-menu-opts]
  (let [{:keys [selections]} widget-menu-opts]
    [:div
     (for [selection (remove nil? selections)]
       ^{:key (:id selection)}
       [header-controls selection id])]))

(defn view
  [id title {:keys [controls tooltip] :as widget-menu-opts}]
  [:div
   {:class [component-name]}
   [:span
    {:class (bem/be component-name :title-icon)}
    [icon :widgets id]]
   [:span
    {:class (bem/be component-name :title)}
    title
    (when tooltip
      [tooltip-wrapper tooltip [:span.widget-info {:style {:padding-left "0.25rem"}} [icon :common :question-mark-circle]]])]
   [:span
    {:class (bem/be component-name :controls)}
    controls]
   [:span
    {:class (bem/be component-name :selections)}
    [selections-menu id widget-menu-opts]]
   [widget-menu (name id) widget-menu-opts]
   [:span
    {:class (bem/be component-name :dismiss)}
    [dismiss-button id]]])
